module.exports = __webpack_public_path__ + "img/project_mobile.f26517f8.png";